module.exports = __webpack_public_path__ + "static/2020-11-06_16-59-44_UTC-6a95e9a943e2acbf11c2771278f7989a.jpg";